<template>
  <div>
    <h1>Unmatched Database (UmDb)</h1>
    <p>
      UmDb collects decklists and information about officially published
      Unmatched decks for you to study to improve your playing, to be understand
      how the decks are constructed, and to better design your own decks.
    </p>
    <p>
      If information is incorrect, or if there is a feature you'd like to see,
      please get in touch.
    </p>

    <nav class="overflow-auto">
      <b-nav tabs class="flex-nowrap text-nowrap d-inline-flex d-sm-flex">
        <b-nav-item
          @click="tabChange('UmDbSetList')"
          :to="{ name: 'UmDbSetList' }"
          exact
          exact-active-class="active"
        >
          Sets
        </b-nav-item>
        <b-nav-item
          @click="tabChange('UmDbDeckList')"
          :to="{ name: 'UmDbDeckList' }"
          exact
          exact-active-class="active"
        >
          Deck info
        </b-nav-item>
        <b-nav-item
          @click="tabChange('UmDbDeckStats')"
          :to="{ name: 'UmDbDeckStats' }"
          exact
          exact-active-class="active"
        >
          Deck stats
        </b-nav-item>
        <b-nav-item
          @click="tabChange('UmDbCardList')"
          :to="{ name: 'UmDbCardList' }"
          exact
          exact-active-class="active"
        >
          Cards
        </b-nav-item>
        <b-nav-item
          @click="tabChange('UmDbBoardList')"
          :to="{ name: 'UmDbBoardList' }"
          exact
          exact-active-class="active"
        >
          Boards
        </b-nav-item>
      </b-nav>
    </nav>

    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "UmDb",
  metaInfo: {
    title: "UmDb",
  },
  data() {
    return {};
  },
  methods: {
    tabChange(tab) {
      this.$store.commit("setPreference", {
        key: "umdbTabName",
        value: tab,
      });
    },
  },
};
</script>
